export { default } from './SuggestionModal';

/** Fired on window to open the suggestion form from anywhere (Ayarlar › Yardım, T-192). */
export const OPEN_SUGGESTION_EVENT = 'riselio:open-suggestion';
